import React from "react";

function Franchise() {
  return <main></main>;
}

export default Franchise;
